import axios from ".";

interface ClientBulkApproveRequest {
  job_ids: string[];
}

interface ClientBulkApproveResult {
  successful_updates: Array<{
    job_id: string;
    old_status: string;
    new_status: string;
    master_id: string;
  }>;
  failed_updates: Array<{
    job_id: string;
    error: string;
    reason: string;
  }>;
  summary: {
    total_requested: number;
    successful: number;
    failed: number;
  };
}

export const clientBulkApproveJobs = async (data: ClientBulkApproveRequest) => {
  return axios.post<{ data: ClientBulkApproveResult }>(
    "/job/client/bulk-approve",
    data
  );
};
